import { toRem, toRems } from 'helpers/theme'

/* eslint-disable quote-props */
const style = ({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    fontSize: toRem(16),
    margin: toRems([5, 0]),

    [theme.breakpoints.up('xl')]: {
        padding: toRems([0, 15]),
        fontSize: toRem(20)
    },
    '& .Icon': {
        marginRight: toRem(20),
        paddingTop: toRem(5),
        svg: {
            width: 40,
            [theme.breakpoints.up('xl')]: {
                width: 60
            }
        }
    }
})

export default style
